import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { AccountPeopleProfile } from 'api/account-people/profile-type';
import { SignalType } from 'api/signal/types';
import moment, { Moment } from 'moment';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { LoadMore } from './load-more';
import { SignalOccurencesForTimePeriod } from './signal-occurrences-for-time-period';
import { getIcon, Sections } from '../../content-navigator';
import { ContentSection } from '../../content-section';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-06);
`;

interface Props {
  userProfile: AccountPeopleProfile;
  sectionKey: Sections;
  isFullWidth?: boolean;
}
type TimePeriod = {
  from: Moment;
  to: Moment;
};

export const GroupedSignalOccurrences = ({
  userProfile,
  sectionKey,
  isFullWidth,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [timePeriods, setTimePeriods] = useState<TimePeriod[]>([
    {
      from: moment().subtract(90, 'days'),
      to: moment(),
    },
  ]);
  const handleLoadMore = useCallback(() => {
    setIsLoading(true);
    const lastTimePeriod = timePeriods[timePeriods.length - 1];

    setTimePeriods([
      ...timePeriods,
      {
        from: moment(lastTimePeriod.from).subtract(90, 'days'),
        to: moment(lastTimePeriod.from).subtract(1, 'day'),
      },
    ]);
  }, [timePeriods]);

  return [Sections.CurrentRisks, Sections.OpportunityLog].includes(
    sectionKey,
  ) ? (
    <ContentSection
      icon={<FontAwesomeIcon icon={getIcon(sectionKey)} size={16} />}
      title={
        sectionKey === Sections.CurrentRisks ? (
          <FormattedMessage id="account.people.profile.sections.current_risks.title" />
        ) : (
          <FormattedMessage id="account.people.profile.sections.opportunity_log.title" />
        )
      }
      sectionKey={sectionKey}
      hasSubHeadingInContent={true}
    >
      <Wrapper>
        {timePeriods.map((timePeriod) => (
          <SignalOccurencesForTimePeriod
            key={timePeriod.from.toISOString()}
            from={timePeriod.from}
            to={timePeriod.to}
            userProfile={userProfile}
            signalType={
              sectionKey === Sections.CurrentRisks
                ? SignalType.Risk
                : SignalType.Opportunity
            }
            onDataLoaded={() => setIsLoading(false)}
            isFullWidth={isFullWidth}
          />
        ))}
        <LoadMore onClick={handleLoadMore} disabled={isLoading}>
          <FormattedMessage
            id={
              sectionKey === Sections.CurrentRisks
                ? 'account.people.current_risks.load_more'
                : 'account.people.opportunity_log.load_more'
            }
          />
        </LoadMore>
      </Wrapper>
    </ContentSection>
  ) : null;
};
